import Facets from 'browse/search/Facets';

export default function search(wrap) {
	if (wrap) {
		new Facets(wrap);

		const sortDropdown = wrap.querySelector('#sortOptions');
		const btnGridView = wrap.querySelector('#btnGridView');
		const btnListView = wrap.querySelector('#btnListView');

		if (sortDropdown && btnGridView && btnListView) {
			sortDropdown.onchange = sortBy;
			btnGridView.onclick = showGridView;
			btnListView.onclick = showListView;
		}
	}

	return !!wrap;
}

function sortBy() {
	this.form.submit();
}

function showGridView() {
	const btnGridView = document.getElementById('btnGridView');

	document
		.getElementById('productList')
		.setAttribute('data-view-type', btnGridView.getAttribute('data-view'));
	document.getElementById('viewSwitcherActiveText').innerHTML =
		btnGridView.innerHTML;
	window.od.Cookie.set('viewType', btnGridView.getAttribute('data-view'));
}

function showListView() {
	const btnListView = document.getElementById('btnListView');

	document
		.getElementById('productList')
		.setAttribute('data-view-type', btnListView.getAttribute('data-view'));
	document.getElementById('viewSwitcherActiveText').innerHTML =
		btnListView.innerHTML;
	window.od.Cookie.set('viewType', btnListView.getAttribute('data-view'));
}
